<template>
  <div>
    <v-card class="user-list pa-5 elevation-3">
      <v-data-table
        :headers="headers"
        :items="userList"
        :items-per-page="10"
        multi-sort
      >
        <template #[`item.user_type`]="{ item }">
          {{ formatUserType(item.user_type) }}
        </template>

        <template #[`item.gender`]="{ item }">
          {{ formatGender(item.gender) }}
        </template>

        <template #[`item.status`]="{ item }">
          {{ formatStatus(item.status) }}
        </template>

        <template #[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-icon
            class="mr-2"
            color="primary"
            :title="$t('common.edit', {item: null})"
            @click="detail(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            color="error"
            :title="$t('common.delete')"
            @click="del(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import moment from 'moment'

export default {
  name: 'UserList',
  mixins: [ErrorDisplay],
  props: {
    userList: {
      type: Array,
      default: () => { return [] }
    }
  },
  data: function () {
    return {
      headers: [
        { text: this.$t('general.username'), value: 'login_id' },
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.tel'), value: 'tel' },
        { text: this.$t('general.userType'), value: 'user_type' },
        { text: this.$t('general.status'), value: 'status' },
        { text: this.$t('general.gender'), value: 'gender' },
        { text: this.$t('general.joinDate'), value: 'created_at' },
        { text: this.$t('common.actions'), value: 'actions' }
      ]
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    formatUserType (userType) {
      if (userType === 'usr') return this.$t('general.user')
      if (userType === 'adm') return this.$t('general.admin')
      return null
    },
    formatGender (gender) {
      if (gender === 0) return this.$t('general.male')
      if (gender === 1) return this.$t('general.female')
      return null
    },
    formatStatus (status) {
      if (status === 0) return this.$t('general.inactive')
      if (status === 1) return this.$t('general.active')
      if (status === -1) return this.$t('general.banned')
      return null
    },
    formatDate (createdAt) {
      moment.locale(this.convertLocale(this.currentLocale, 'bcp47'))
      if (moment(createdAt).isValid()) return moment(createdAt).format('LLL')
      return null
    },
    detail (item) {
      this.$emit('detail', item)
    },
    del (item) {
      this.$emit('del', item)
    }
  }
}
</script>

<style scoped>
.user-list {
  width: 100%
}
</style>
